module.exports = __webpack_public_path__ + "img/bayonetta.7cacbcea.png";